import React, { useMemo, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/buttons/buttons";
import Table from "../../../components/tables/tableCols1";
import TableSkeleton from "../../../components/skeleton/table";
import TableFilter from "../../../components/tables/tableFilter";
import Empty from "../../../assets/images/emptyState/promo-code.svg";
import { Pagination } from "../../../components/pagination/pagination";
import { filterDeliveryModes, searchDeliveryModes } from "../../../redux/deliveryMode/deliveryModeAction";
import deliveryModeType from "../../../redux/deliveryMode/deliveryModeTypes";
import { writeFileWithXLSX } from "../../../components/exports/xlsx";
import FilterPromoDropDown from "../../../components/dropDown/filter/promoFilter";
import { AllFiltersModal } from "../../../components/modals/allFiltersModal";
import { CreateDeliveryModeModal } from "../../../components/modals/admin/deliveryMode/createDeliveryModeModal";
import { EditDeliveryModeModal } from "../../../components/modals/admin/deliveryMode/editDeliveryModeModal";

export default function All() {
  const dispatch = useDispatch();
  const { page } = useParams();
  let lastMonth = new Date();
  lastMonth.setDate(lastMonth.getDate() - 30);

   const { allDeliveryModes, filtering, searching } = useSelector(
    (state) => state.deliveryMode
  );
  
  const [isFilterOpen, setFilterState] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [payLoad] = useState({
    end_date: new Date(),
  });

  const [data, setData] = useState([]);
  const [input, setInput] = useState({
    search: "",
  });

  useEffect(() => {
    dispatch(filterDeliveryModes(payLoad, page));
    // eslint-disable-next-line
  }, [page]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((code, index) => {
        let show = {
          id:
            (allDeliveryModes?.current_page - 1) * allDeliveryModes?.per_page +
            index +
            1,
          title: code?.title,
          created: (
            <span>
              {moment(code?.created_at).format("MMM DD, YYYY/ HH:MMA")}
            </span>
          ),
          action: (
            <EditDeliveryModeModal
              deliveryMode={code}
              onSuccess={() => dispatch(filterDeliveryModes(payLoad, page))}
            />
          ),
          coupon: code,
        };
        outputArray.push({ show });
        return true;
      });
      return outputArray;
    }
  }

  useEffect(() => {
    const dataSet = createTableData(allDeliveryModes?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allDeliveryModes]);

  function createTableNoPage(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((code, index) => {
        let show = {
          title: code?.title,
          created: code?.created_at,
        };
        outputArray.push(show);
        return true;
      });
      return outputArray;
    }
  }

  function openEditModal(_params) {
    // row click handler — edit is handled inline via EditDeliveryModeModal
  }

  const downloadCSV = async () => {
    const response = await dispatch(
      filterDeliveryModes({
        ...payLoad,
        pagination: 0,
      })
    );
    if (response) {
      const newData = createTableNoPage(response?.data);
      writeFileWithXLSX(newData, {
        filename: "All_delivery_modes.xlsx",
        download: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
    setIsSearchOpen(true);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allDeliveryModes?.data);
      setData(dataSet);
      setIsSearchOpen(false);
      dispatch({
        type: deliveryModeType["SEARCH_DELIVERY_MODE"],
        payLoad: { data: [] },
      });
    }
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchDeliveryModes(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        columns: [
          {
            Header: "S/N",
            accessor: "show.id",
          },
          {
            Header: "Title",
            accessor: "show.title",
          },
          {
            Header: "Date Created",
            accessor: "show.created",
          },
          {
            Header: "Action",
            accessor: "show.action",
          },
        ],
      },
    ],
    []
  );

  return (
    <div data-test="all-promo">
      <TableFilter
        title={"Delivery Modes"}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        results={allDeliveryModes?.to}
        totalResults={allDeliveryModes?.total}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterPromoDropDown
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
        searchPlaceholder={"Title or City"}
      >
        <CreateDeliveryModeModal onSuccess={() => dispatch(filterDeliveryModes(payLoad, page))} />
        <Button.Secondary
          title={"Download CSV"}
          onClick={() => downloadCSV()}
          disabled={!data}
        />
      </TableFilter>
      <div className="border-b border-[#E4E4F3]"></div>

      <div className="bg-white dark:bg-[#121212] rounded-md py-4 px-3">
        {filtering || searching ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={openEditModal}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="text-center">
            {" "}
            <div className="flex justify-center my-12 ">
              <img src={Empty} alt="coupon" />
            </div>
            <p className="font-bold text-xl my-3">Promo Code</p>
            <p className="text-sm text-gray-500">
              You have not created any promo yet.
            </p>
          </div>
        )}

        {!isSearchOpen && (
          <Pagination data={allDeliveryModes} route={`admin/promo/all`} />
        )}
      </div>
    </div>
  );
}
